import { BusinessUnitKey } from '@/modules/bu/bu.types';
import type { RouteRecordRaw } from 'vue-router';
import routes from './routes/cleepo.routes';

// Discovered by the BU registry; see `src/modules/bu/registry.ts`.
export const key = BusinessUnitKey.Cleepo;
export default routes;

// Unprefixed paths this product used to own, kept for old links.
export const legacyRoutes: RouteRecordRaw[] = [
  {
    path: '/geo',
    redirect: '/cleepo',
    children: [
      {
        path: ':pathMatch(.*)*',
        redirect: '/cleepo',
      },
    ],
  },
];
